// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___308rc","addText":"AddFilterBox__addText___3sHth","addFilterContainer":"AddFilterBox__addFilterContainer___2aCeD","addIcon":"AddFilterBox__addIcon___2uZuM"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/potentialMatches/components/advancedSearch/AddFilterBox.scss
// module id = 1621
// module chunks = 0